import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../cx';
import styles from './Card.module.css';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Adds default body padding. Turn off when composing Card.Header/Body/Footer yourself. */
  padded?: boolean;
  interactive?: boolean;
}

export function Card({ padded = false, interactive = false, className, children, ...rest }: CardProps) {
  return (
    <div className={cx(styles.card, padded && styles.padded, interactive && styles.interactive, className)} {...rest}>
      {children}
    </div>
  );
}

export function CardHeader({ title, actions }: { title: ReactNode; actions?: ReactNode }) {
  return (
    <div className={styles.header}>
      <div className={styles.title}>{title}</div>
      {actions}
    </div>
  );
}

export function CardBody({ children, className }: { children: ReactNode; className?: string | undefined }) {
  return <div className={cx(styles.body, className)}>{children}</div>;
}

export function CardFooter({ children }: { children: ReactNode }) {
  return <div className={styles.footer}>{children}</div>;
}
